import { render, staticRenderFns } from "./SwitchList.vue?vue&type=template&id=658b4a6a&scoped=true"
import script from "./SwitchList.vue?vue&type=script&lang=js"
export * from "./SwitchList.vue?vue&type=script&lang=js"
import style0 from "./SwitchList.vue?vue&type=style&index=0&id=658b4a6a&prod&lang=scss"
import style1 from "./SwitchList.vue?vue&type=style&index=1&id=658b4a6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658b4a6a",
  null
  
)

export default component.exports